import {
  ApiSavedSearch,
  ApiSavedSearchUnsaved,
} from 'api/savedSearch/types/ApiSavedSearch';
import { del } from 'utils/http/del';
import { postJson } from 'utils/http/postJson';
import { putJson } from 'utils/http/putJson';

export async function apiCreateSavedSearch({
  text,
  filters,
  location,
  index,
  radius,
}: ApiSavedSearchUnsaved): Promise<ApiSavedSearch> {
  const { savedSearch } = await postJson<{ savedSearch: ApiSavedSearch }>(
    '/data/saved-searches',
    {
      text,
      filters,
      radius,
      location,
      index,
    },
  );
  return savedSearch;
}

export async function apiEditSavedSearch(
  id: string,
  { name, notifyByEmail }: { name: string; notifyByEmail: boolean },
): Promise<ApiSavedSearch> {
  const { savedSearch } = await putJson<{ savedSearch: ApiSavedSearch }>(
    `/data/saved-searches/${id}`,
    {
      name,
      notifyByEmail,
    },
  );
  return savedSearch;
}

export function apiDeleteSavedSearch(searchId: string) {
  return del(`/data/saved-searches/${searchId}`);
}
